<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"700px"'
    :cpntTitulo='cpntTitulo'

    :cpntOnFecharDialog='proConsultaFechar'
    ref="dialog">
    <template slot='conteudo'>
      <div class="app-pro-consulta" ref="dados">
        <App-Produto-Consultar-Conteudo :key="dados.id" v-if="$store.state.mobile === false"
        :cpntId="dados.id"
        :cpntNome="dados.nome"
        :cpntIdCat="dados.id_cat"
        :cpntUnidade="dados.id_uni"
        :cpntUnidadeDescricao="dados.virtual_id_uni_desc"
        :cpntValorVen="dados.valor_ven"
        :cpntMostrarEstoque="colunas.indexOf('estoque') !== -1"
        :cpntMostrarEstoqueSincronizado="colunas.indexOf('estoque_sincronizado') !== -1"
        :cpntEstoque="dados.virtual_qtde_estoque"
        :cpntEstoqueSincronizado="dados.virtual_qtde_estoque_com_clu_sincronizada"
        :cpntAcaoProdutoEditar="proConsultaOnAbrirCadastroProduto"
        :cpntAcaoProdutoHistorico="proConsultaOnAbrirHistorico"
        ></App-Produto-Consultar-Conteudo>

        <RF-Dialog v-else-if="$store.state.mobile === true && Object.keys(dados).length >= 1 && [ '', null, undefined ].indexOf(dados.id) === -1"
        :cpntStatus='statusGeral'
        :cpntLargura='"700px"'
        :cpntTitulo='cpntTitulo'

        :cpntOnFecharDialog='() => { dados = {} }'
        ref="dialog">
        <template slot='conteudo'>
          <div class="app-pro-consulta" ref="dados">
            <App-Produto-Consultar-Conteudo :key="dados.id"
            :cpntId="dados.id"
            :cpntNome="dados.nome"
            :cpntIdCat="dados.id_cat"
            :cpntUnidade="dados.id_uni"
            :cpntUnidadeDescricao="dados.virtual_id_uni_desc"
            :cpntValorVen="dados.valor_ven"
            :cpntMostrarEstoque="colunas.indexOf('estoque') !== -1"
            :cpntMostrarEstoqueSincronizado="colunas.indexOf('estoque_sincronizado') !== -1"
            :cpntEstoque="dados.virtual_qtde_estoque"
            :cpntEstoqueSincronizado="dados.virtual_qtde_estoque_com_clu_sincronizada"
            :cpntAcaoProdutoEditar="proConsultaOnAbrirCadastroProduto"
            :cpntAcaoProdutoHistorico="proConsultaOnAbrirHistorico"
            ></App-Produto-Consultar-Conteudo>
          </div>
        </template>
        </RF-Dialog>

        <div class="app-pro--busca" ref="busca">
          <App-Autocompletar :data-time="time" :class="campos.busca.id"
            :cpntStatus='campos.busca.status'
            :cpntId='campos.busca.id'
            :cpntTabIndex='campos.busca.tabIndex'
            :cpntNome='campos.busca.nome'
            :cpntValue='campos.busca.value'
            :cpntMensagem='campos.busca.mensagem'
            :cpntMensagemTipo='campos.busca.mensagemTipo'
            :cpntDisabled='campos.busca.disabled'
            :cpntMostrar='campos.busca.mostrar === true'
            :cpntExplica='campos.busca.explica'
            :cpntPlaceholder='campos.busca.placeholder'
            :cpntValueRef='campos.busca.valueRef'
            :cpntRouter='campos.busca.router'
            :cpntMethod='campos.busca.method'
            :cpntField='campos.busca.field'
            :cpntFieldVirtual='campos.busca.fieldVirtual'
            :cpntWhere='campos.busca.where'
            :cpntAddButForm='campos.busca.addButForm'
            :cpntKeyMostra='campos.busca.keyMostra'
            :cpntTipoOrder='campos.busca.tipoOrder'
            :cpntOrder='campos.busca.order'
            :cpntOptions='campos.busca.options'
            :cpntKeyValue='campos.busca.keyValue'
            :cpntSearchMinimo='campos.busca.searchMinimo'
            :cpntMask='campos.busca.mask'
            :cpntNewOption='campos.busca.newOption'
            :cpntNoOptions='false'

            :cpntInputOnKeyUp='campos.busca.onKeyUp'
            :cpntInputOnKeyDown='campos.busca.onKeyDown'
            :cpntOnBuscarOptions='campos.busca.onBuscarOptions'
            :cpntOnChange='campos.busca.onChange'
            :cpntOnBlur='campos.busca.onBlur'
            :cpntOnRealizaBusca='campos.busca.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.busca.onKeyPressEnter'
            ref="input"
          ></App-Autocompletar>
        </div>
      </div>

      <div class="app-pro--dados">
        <!-- SETA A TABELA DE DADOS -->
        <App-Produto-Gerenciar :cpntConsultar="true" ref="tabela" :cpntSelecionar="(dados, indexL) => { proConsultaOnSelecionarLinha(indexL) }">
          <template slot='carregar_mais' v-if="carregados >= 1 && total > carregados">
            <div style="text-align: center;">
              <App-Button :cpntClass="'btn btn-primary btn-sm'" :cpntStatus="statusCarregarMais" @onClick="() => { proConsultaOnBuscarOptions('__CARREGAR_MAIS__', null) }">Carregar mais</App-Button>
            </div>
          </template>
        </App-Produto-Gerenciar>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.app-pro--busca {
  width: 350px;
  margin: 0px auto;
  margin-top: 30px;
  margin-bottom: 15px;
}
</style>

<style>
  /* .app-pro-consulta,
  .app-pro-consulta ~ .app-pro--dados {
    max-width: calc(100% - 50px);
  } */

  .app-pro--dados > .pro-ger {
    /* height: 430px;
    overflow: auto; */
    margin-top: 10px;
  }


  .app-pro--dados > .pro-ger:not(.no-scroll) > .tabela > table {
    max-width: 100%;
    table-layout:fixed;
    margin:auto;
  }
  
  .app-pro--dados > .pro-ger:not(.no-scroll) > .tabela > table > thead, 
  .app-pro--dados > .pro-ger:not(.no-scroll) > .tabela > table > tfoot {
    display:table;
    width:100%;
    width:calc(100% - 13px);
  }
  .app-pro--dados > .pro-ger:not(.no-scroll) > .tabela > table > tbody {
    max-height: calc(100vh * 0.80);
    overflow: auto;
    overflow-x: hidden;
    display: block;
    width: 100%;
  }
  .app-pro--dados > .pro-ger:not(.no-scroll) > .tabela > table > tbody > tr {
    display:table;
    width:100%;
    table-layout:fixed;
  }

  .app-pro--dados > .pro-ger > .tabela > table > tbody > tr > td {
    padding: 5px
  }
  .app-pro--dados > .pro-ger > .tabela > table > thead > tr > th.col_nome,
  .app-pro--dados > .pro-ger > .tabela > table > tbody > tr > td.col_nome {
    width: 315px;
    min-width: 315px;
    max-width: 315px;
  }
    .app-pro--dados > .pro-ger > .tabela > table > tbody > tr > td.col_nome,
    .app-pro--dados > .pro-ger > .tabela > table > tbody > tr > td.col_nome > div,
    .app-pro--dados > .pro-ger > .tabela > table > tbody > tr > td.col_nome > div > span,
    .app-pro--dados > .pro-ger > .tabela > table > tbody > tr > td.col_nome > div > span > button {
      text-align: left;
    }
    

  .app-pro--dados > .pro-ger > .tabela > table > thead > tr > th.col_ncm,
  .app-pro--dados > .pro-ger > .tabela > table > tbody > tr > td.col_ncm,
  .app-pro--dados > .pro-ger > .tabela > table > thead > tr > th.col_id_uni,
  .app-pro--dados > .pro-ger > .tabela > table > tbody > tr > td.col_id_uni {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
  }

  .app-pro--dados > .pro-ger > .tabela > table > thead > tr > th.col_selecionar {
    width: 65px;
    min-width: 65px;
    max-width: 65px;
  }
    .app-pro--dados > table > tr > td > .acoes > button > span > img {
      width: 12px;
      height: 12px;
    }
    .app-pro--dados > table > tr > td > .acoes > button > span > span > svg {
      font-size: 11px;
    }

  .app-pro--dados > .pro-ger > .tabela > table > tbody > tr > td {
    border-top: none !important;
  }
</style>

<script>
  export default {
    props: {
      cpntTitulo: {
        required: true,
        default: function () {
          return 'Consultar Produto <b>[ALT+P]</b>'
        }
      },
      cpntSelecionar: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'App-Produto-Consultar-Conteudo': () => import('@/components/produto/gerenciar/Produto-Consultar-Conteudo.vue'),
      'App-Produto-Gerenciar': () => import('@/components/produto/gerenciar/Produto-Gerenciar.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        colunas: [],
        dados: {},
        statusCarregarMais: '',
        carregados: 0,
        total: 0,
        currentFocus: undefined,
        campos: {
          busca: {
            id: 'con-busca--busca',
            status: '',
            // newOption: {
            //   tipo: 'icone',
            //   icone: { tipo: 'ico-mais' },
            //   explica: { titulo: '', mensagem: 'Adicionar novo contato' },
            //   class: [ 'btn', 'btn-primary', 'btn-sm' ],
            //   onClick: (string) => { this.proConsultaOnAbrirCadastroProduto(string) }
            // },
            nome: 'Buscar produto',
            router: '/produto/get',
            method: 'POST',
            field: { id: null, codigo: null, cod_barra: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } }, id_pco_status: { j: { nome: null } }, valor_ven_novo: { a: 'valor_ven' } },
            fieldVirtual: [],
            where: 'dem-edi-pro',
            keyValue: 'id',
            keyMostra: [ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ],
            disabled: false,
            mostrar: true,
            value: '',
            mensagem: '',
            mensagemTipo: '',
            onChange: this.proConsultaOnChange,
            onRealizaBusca: (busca) => {
              // LIMPA O VALOR DO CAMPO SELECIONADO
              this.campos.busca.value = busca

              // LIMPA O VALOR DO CAMPO SELECIONADO
              this.campos.busca.valueRef = ''

              // LIMPA OS VALORES DOS CAMPO
              this.dados = {}

              // LIMPA O TOTAL DE REGISTROS DA PESQUISA
              this.total = 0

              // LIMPA O TOTAL DE REGISTROS DA PESQUISA
              this.carregados = 0

              // LIMPA OS VALORES DA TABELA
              if ([ '', null, undefined ].indexOf(busca) !== -1 || busca.length < 2) {
                // ATUALIZA A TABELA
                this.$refs.tabela.proGerTabSetarLinhas([])
  
                // SETA O STATUS DA TABELA
                this.$refs.tabela.proGerTabSetarStatusGeral('')
              }
            },
            onBuscarOptions: this.proConsultaOnBuscarOptions,
            // onKeyUp: this.proConsultaOnKeyPress,
            onKeyDown: this.proConsultaOnKeyPress
          }
        }
      }
    },
    mounted: function () {
      this.proConsultaIniciar()
    },
    methods: {
      proConsultaIniciar: function () {
        // SETA O FOCUS DA PAGINA
        this.proConsultaSetarStatusGeral('')

        // SETA AS COLUNAS QUE DEVE MOSTRAR
        this.colunas = [ 'unidade', 'valor' ]

        // VERIFICA SE TEM O PACOTE DE CONTROLE DE ESTOQUE
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5, 17 ], 'and', null, null, null, null, false) === true) {
          // ADICIONA A COLUNA ESTOQUE
          this.colunas.push('estoque')
          
          // VERIFICA AS LICENÇAS TEM ESTOQUE SINCRONIZADO
          if (this.$store.state.token.sincronismo === true) {
            this.colunas.push('estoque_sincronizado')
          }
        }

        // VERIFICA AS LICENÇAS DE USO QUE DEVE MUDAR A PESQUISA
        if ([ '3126', '3154', '3155', '9122', '9123', '9124' ].indexOf(this.$store.state.token.clu) !== -1) {
          // SETA OS CAMPOS QUE DEVE MOSTRAR NO AUTO COMPLITE
          this.campos.busca.field = Object.assign(this.campos.busca.field, {
            id_for: { j: { nome: null } }
          })

          // SETA O MODO DE EXIBIÇÃO
          this.campos.busca.keyMostra = [ 'nome', ' - R$ ', 'valor_ven', ' - ', 'id_for_nome', ' - ', 'codigo' ],

          // SETA O WHERE QUE DEVE REALIZAR
          this.campos.busca.where = {
            aAnd: [
              { f: 'status', o: '=', v: '1' },
              { aOr: [
                { f: 'nome',      o: 'locate', v: '#BUSCA#' },
                { f: 'codigo',    o: 'locate', v: '#BUSCA#' },
                { f: 'cod_barra', o: 'locate', v: '#BUSCA#' },
                { f: 'nome',      o: 'locate', v: '#BUSCA#' }
              ] }
            ]
          }
        }

        // SETA O FOCUS NO CAMPO
        setTimeout(() => { this.proConsultaRealizarFocusCampo('input') }, 500)

        // SETA O TAMANHO MAXIMO DA DIV
        setTimeout(() => { this.proConsultaOnMontarAlturaDivScroll() }, 1000)

        // setTimeout(() => {
        //   this.proConsultaOnBuscarOptions('301', () => {})
        // }, 2000)
      },
      proConsultaSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proConsultaFechar: function (atualizar = false, id = null, dados = null) {
        if (atualizar === true && id !== null && dados === null) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVEM RETORNAR
          queryGet.field = {
            id: null,
            codigo: null,
            nome: null,
            ncm: null,
            cest: null,
            ind_escala: null,
            cnpj_fab: null,
            c_benef: null,
            id_uni: null,
            id_uni_trib: null,
            qtde_trib: null,
            cod_barra_trib: null,
            id_tp_item: null,
            cod_barra: null,
            anp_cod: null,
            anp_desc: null,
            glp_p_glp: null,
            glp_p_gnn: null,
            glp_p_gni: null,
            glp_v_par: null,
            id_cat: { j: { nome: null } },
            id_mar: { j: { nome: null } },
            // qtde_ini: null,
            qtde_min: null,
            id_for: { j: { id: null, nome: null, empresa: null, cnpj_cpf: null } },
            valor_for_novo: { a: 'valor_for' },
            markup_por: null,
            valor_fixo_novo: { a: 'valor_fixo' },
            valor_ven_novo: { a: 'valor_ven' },
            obs: null,
            est_calc: null,
            updated_user: { j: { usuario: null } },
            updated_at: null
          }

          // VERIFICA SE O CAMPO EXISTE
          if (this.$store.state.pcoAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true) {
            queryGet.field.id_pco_status = null
          }

          // VERIFICA SE TEM O PACOTE INSUMOS E UTILIZA A VERSÃO ANTIGA
          if (this.$store.state.insAntigo === true && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 12 ], null, null, null, null, null, false) === true) {
            queryGet.field.id_ins_rec = null
            queryGet.field.id_pro_est = null
          }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'id', o: '=', v: id }
          
          // INICIA A VARIAVEL DO CAMPO VIRTUAL SE ELA NÃO EXISTIR
          queryGet.field_virtual = [ 'id_uni_desc', 'id_uni_trib_desc', 'id_tp_item_desc' ]

          // VERIFICA SE DEVE BUSCAR A QUANTIDADE EM ESTOQUE
          if (this.colunas.indexOf('estoque') !== -1) {
            queryGet.field_virtual.push('qtde_estoque')
          }

          // VERIFICA SE DEVE BUSCAR A QUANTIDADE EM ESTOQUE
          if (this.colunas.indexOf('estoque_sincronizado') !== -1) {
            queryGet.field_virtual.push('qtde_estoque_com_clu_sincronizada')
          }

          // COMUNICA COM A API
          this.$store.state.comunicaAPI('/produto/get', 'POST', queryGet, (retorno) => {            
            this.proConsultaFechar(true, id, retorno.data[0])
          }, this.proConsultaSetarStatusGeral)
        } else {
          switch (this.cpntSelecionar + '_' + atualizar) {
            case 'true_true':
            case 'true_false':
            case 'false_false':
              this.cpntFecharFormulario(atualizar, id, dados)
              break
            
            case 'false_true':
              // SETA OS DADOS RECEBIDOS
              this.dados = dados

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
              break
          }
        }
      },
      proConsultaOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF], 'mensagem', '')

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF], 'class', '')

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF) {
          case 'busca':
            this.proConsultaFechar(true, value.id)
            break
        }
      },
      proConsultaOnAbrirCadastroProduto: function (string, id = 0) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { tipo: 'produto', id: id, nome: string, editar: true }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id, dados) => {
          if (atualizar === true) {
            this.proConsultaOnChange(dados, this.campos.busca.id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      proConsultaRealizarFocusCampo: function (chave, tentativa = 0) {
        // SETA O FOCUS NO CAMPO
        if (tentativa <= 10) {
          if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
            this.$refs[chave].cpntRealizarFocus()
          } else {
            setTimeout(() => { this.proConsultaRealizarFocusCampo(chave, (tentativa + 1)) }, 250)
          }
        }
      },
      proConsultaOnAbrirHistorico: function () {
        // CARREGA OS PARAMETROS
        var params = { name: 'produto_historico_busca', params: { cts: this.$store.state.token.cts, cpntFiltros: window.btoa(JSON.stringify({ pro: [ this.dados.id.toString() ] })) } }

        // ABRE O RECIBO DA DEMANDA SOLICITADO
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, '_blank', {}, false)
      },
      //   this.$store.state.OPEN_PAGE_CS(process.env.VUE_APP_URL_CS + '/app/produtos/produtos_his.php?cts=' + this.$store.state.token.cts + '&p=' + this.dados.id + '&c=' + this.dados.id_cat, '_blank')
      // },
      proConsultaOnBuscarOptions: function (busca, callback = null) {
        // INICIA A VARIAVEL PARA NÃO DAR ERRO
        if (callback === null) {
          callback = () => {}
        }

        // QUEBRA SINCRONISMO DO VUE
        setTimeout(() => {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) !== -1 || (this.carregados !== 0 && this.carregados >= this.total)) {
            callback([])
          } else {
            // VERIFICA SE DEVE JUNTAR OS VALORES
            var concatenar = busca === '__CARREGAR_MAIS__'

            // ATUALIZA O VALOR RECEBIDO
            if (busca === '__CARREGAR_MAIS__') {
              // SETA O VALOR QUE DEVE SER BUSCADO
              busca = this.campos.busca.value

              // REMOVE O FOCUS DE QUALQUER CAMPO
              if (document.activeElement !== document.body) {
                document.activeElement.blur()
              }
            }
            
            // SETA O STATUS DE CARREGANDO
            this.statusCarregarMais = 'carregando'
            
            // INICIA A QUERY QUE DEVE REALIZAR
            var queryGet = { type: 'list', limit: { row: this.carregados, qty: 50 }, where: {} }

            // LIMITA A QUANTIDADE DE REGISTRO NO CELULAR
            if (this.$store.state.mobile === true) {
              queryGet.limit.qty = 10
            }
  
            // PEGA O WHERE QUE DEVE RALIZAR
            queryGet.where = this.campos.busca.where
  
            // VERIFICA SE TEM CONSULTA PERSONALIZADA
            if (queryGet.where === 'dem-edi-pro') {
              queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }
            }
  
            // CONVERTE O VALOR RECEBIDO EM JSON STRING
            queryGet.where = JSON.stringify(queryGet.where)
  
            // CONVERTE TODOS OS VALORES DE BUSCA
            while (queryGet.where.indexOf('#BUSCA#') !== -1) {
              queryGet.where = queryGet.where.replace('#BUSCA#', busca)
            }
  
            // CONVERTE EM OBJETO O VALOR RECEBIDO
            queryGet.where = JSON.parse(queryGet.where)
            
            // SETA OS FIELDS QUE DEVE BUSCAR
            queryGet.field = JSON.parse(JSON.stringify(this.$refs.tabela.field))
            queryGet.field_virtual = JSON.parse(JSON.stringify(this.$refs.tabela.fieldVir))
            
            // REMOVE A PAGINAÇÃO DO CAMPO
            if (this.$refs.tabela.estruturaQueryGet[0].indexOf('SemPaginacao') === -1) {
              this.$refs.tabela.estruturaQueryGet[0].push('SemPaginacao')
            }
  
            // COMUNICA COM A API
            this.$store.state.comunicaAPI('/produto/get', 'POST', queryGet, (retorno) => {
              if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1) {
                // PEGA AS LINHAS DA TABELA
                var linhas = concatenar === true ? JSON.parse(JSON.stringify(this.$refs.tabela.linha)) : []

                // JUNTA COM AS LINHAS RECEBIDAS
                linhas = linhas.concat(retorno.data)

                // ATUALIZA A TABELA
                this.$refs.tabela.proGerTabSetarLinhas(linhas)
    
                // SETA O STATUS DA TABELA
                this.$refs.tabela.proGerTabSetarStatusGeral('')
    
                // FINALIZA O CARREGAMENTO
                setTimeout(() => {
                  // FINALIZA O CARREGAMENTO
                  callback([])
    
                  // SETA O NOVO VALOR SELECIONADO
                  if (concatenar === false && retorno.data.length >= 1 && this.$store.state.mobile === false) {
                    this.proConsultaOnSelecionarLinha(0)
                  }

                  // SETA O TOTAL CARREGADO
                  this.carregados = (this.carregados + retorno.data.length)

                  // SETA O TOTAL DA PESQUISA
                  this.total = Number(retorno.countAll)

                  // SETA O STATUS DE CARREGANDO
                  this.statusCarregarMais = ''
                }, 0)
              }
            }, this.proConsultaSetarStatusGeral)
          }
        }, 0)
      },
      proConsultaOnMontarAlturaDivScroll: function () {
        // PEGA A DIALOG QUE ESTÁ ABERTA
        var dialog = this.$refs.dialog.$el.querySelector('.app-dialog-contant')

        // PEGA A DIG COM BARRA DE ROLAGEM
        var tbody = this.$refs.tabela.$el.querySelector('tbody')

        // PEGA A DIG COM BARRA DE ROLAGEM
        var dados = this.$refs.dados

        // PEGA A ALTURA DA DIALOG
        var altura = dialog.style.maxHeight 

        // REMOVE VALORES NÃO UTILIZADOS NA STRING
        altura = altura.replace('calc(', '')
        altura = altura.replace('px)', '')

        // SETA A ALTURA ATUALIZADA
        altura = (altura - dados.offsetHeight - 65 - 40)

        // SETA O TAMANHO PARA FAZER BARRA DE ROLAGEM NA TABELA
        if (altura >= 210) {
          tbody.style.maxHeight = altura + 'px'
        } else {
          this.$refs.tabela.$el.classList.add('no-scroll')
        }

        if (altura >= 0) {
          // PEGA A DIG COM BARRA DE ROLAGEM
          var div = this.$refs.tabela.$el

          // SETA A ALTURA MINIMA PARA GANHAR ESPAÇO
          div.style.minHeight = (altura + 25) + 'px'
        }
      },
      proConsultaOnSelecionarLinha: function (indexL) {
        if ([ '', null, undefined ].indexOf(this.$refs.tabela.linha[indexL]) === -1) {
          // LIMPA A CLASSE DOS CAMPOS
          for (var index in this.$refs.tabela.linha) {
            this.$refs.tabela.linha[index]._fundoN = ''
          }
  
          // SETA O FUNDO SELECIONADO
          this.$refs.tabela.linha[indexL]._fundoN = 'background-tp-1'
  
          // SETA O FOCUS DA LINHA
          this.$refs.tabela.$refs.tabela.focusL = indexL
  
          // PEGA OS TRS DA TABELA
          var tr = this.$refs.tabela.$refs.tabela.$el.querySelectorAll('tbody > tr')
  
          // PEGA APENAS O TR QUE IMPORTA
          tr = tr[indexL]
  
          // RODA O SCROLL ATÉ O CAMPO
          tr.scrollIntoView({ behavior: 'smooth', block: 'start' })
  
          // SETA O FOCUS ATUALIZADO
          this.currentFocus = indexL
  
          // MANDA ATUALIZAR O REGISTRO SELECIONADO
          this.proConsultaFechar(true, this.$refs.tabela.linha[indexL].id)
        }
      },
      proConsultaOnKeyPress: function (event) {
        if (event.keyCode === 38 || event.keyCode === 40) {
          // PARA O PROCESSO DE PROPAGARAÇÃO
          event.preventDefault()
          
          // VERIFICA O CAMPO QUE DEVE SELECIONAR
          if (this.currentFocus === undefined) {
            this.currentFocus = 0
          } else {
            this.currentFocus += event.keyCode === 38 ? -1 : 1
          }
          
          // VERIFICA SE JÁ PASSOU DO ULTIMO REGISTRO
          if (this.currentFocus < 0) {
            this.currentFocus = 0
          } else if ((this.$refs.tabela.linha.length - 1) < this.currentFocus) {
            this.currentFocus = (this.$refs.tabela.linha.length - 1)
          }

          // VERIFICA SE TEM QUE SELECIONAR A LINHA
          if (this.currentFocus >= 0) {
            this.proConsultaOnSelecionarLinha(this.currentFocus)
          }
        }
      }
    }
  }
</script>
